import React from 'react';

const Blog = () => {
    return (
        <div className='mt-4 w-75 mx-auto'>
            <div className="card border-primary mb-3">
                <div className="card-header text-primary fs-4 fw-bold">What is the purpose of React Router?</div>
                <div className="card-body text-primary">
                    <p className="card-text fs-6">React Router is a standard library for routing in React. It enables the navigation among views of various components in a React Application, allows changing the browser URL, and keeps the UI in sync with the URL.<br/>React Router, and dynamic, client-side routing, allows us to build a single-page web application with navigation without the page refreshing as the user navigates. </p>
                </div>
            </div>
            <div className="card border-primary mb-3">
                <div className="card-header text-primary fs-4 fw-bold">How does context api works?</div>
                <div className="card-body text-primary">
                    <p className="card-text fs-6">The React Context API is a way for a React app to effectively produce global variables that can be passed around. This is the alternative to "prop drilling" or moving props from grandparent to child to parent, and so on. Context is also touted as an easier, lighter approach to state management using Redux.</p>
                </div>
            </div>
            <div className="card border-primary mb-3">
                <div className="card-header text-primary fs-4 fw-bold">What can we do with useRef?</div>
                <div className="card-body text-primary">
                    <p className="card-text fs-6">The useRef is a hook that allows to directly create a reference to the DOM element in the functional component.The useRef returns a mutable ref object. It can be used to store a mutable value that does not cause a re-render when updated. If we tried to count how many times our application renders using the useState Hook, we would be caught in an infinite loop since this Hook itself causes a re-render.To avoid this, we can use the useRef Hook.</p>
                </div>
            </div>
        </div>

    );
};

export default Blog;